module.exports = __webpack_public_path__ + "static/media/0001.5e650c76.jpg";